import React from "react";
import icon1 from "../../assets/OfferingB/build_integrations1.svg";
import icon2 from "../../assets/OfferingB/build_integrations2.svg";
import icon3 from "../../assets/OfferingB/build_integrations3.svg";

const pic1 = "https://storage.googleapis.com/think41-web-new/assets/OfferingB/build_ai_int_12.svg"

const features = [
  {
    icon: icon1,
    text: "Plug AI into live workflows, not side experiments",
    description:
      "Integrate AI directly into core business processes to ensure real-time impact and avoid isolated or experimental implementations.",
  },
  {
    icon: icon2,
    text: "Enable data-to-action automation across teams",
    description:
      "Automate the flow from data collection to actionable insights, empowering cross-functional teams to collaborate efficiently and make informed decisions.",
  },
  {
    icon: icon3,
    text: "Drive adoption through low-friction integration",
    description:
      "Simplify AI integration with minimal disruption, encouraging widespread use and faster acceptance across all organizational levels and systems.",
  },
];

const BuildIntegration = () => {
  return (
    <section className="w-full h-[650px] md:h-[800px]">
      {/* ——— Mobile Only ——— */}
      <div className="md:hidden flex flex-col items-center px-5 md:py-10">
        {/* 1. Heading */}
        <h2 className="text-[24px] font-semibold mb-2 w-full font-montserrat">
          Build Integrations
        </h2>

        {/* 2. Paragraph */}
        <p className="text-[16px] font-light mb-6 w-full font-roboto">
          Build bridges between AI and your existing systems for seamless
          orchestration and interoperability.
        </p>

        {/* 3. Main Image */}
        <div className="w-full flex justify-center mb-6">
          <img
            src={pic1}
            alt="integration graphic"
            className="w-[90%] max-w-[350px]"
          />
        </div>

        {/* 4. Card Array */}
        <div className="flex flex-col items-center space-y-4 w-full font-roboto">
          {features.map((feature, i) => (
            <div
              key={i}
              className="bg-white rounded-md shadow overflow-hidden text-[#2D3139] px-[20px] py-[16px] font-[16px] h-[80px] flex items-center w-full"
            >
              <p>{feature.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ——— Desktop / Tablet Layout ——— */}
      <div className="hidden md:flex gap-20 justify-center w-full h-full max-w-[1440px] px-[120px] min-h-[600px] mx-auto">
        <div className="flex items-center">
          <img src={pic1} alt="" className="object-contain" />
        </div>

        <div className="flex flex-col justify-center">
          <div
            className="text-[40px] font-[600] bg-clip-text text-transparent font-montserrat mb-4"
            style={{
              backgroundImage: "linear-gradient(90deg, #000 0%, #0060C7 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Build Integrations
          </div>

          <p className="mb-[24px] leading-8 font-light font-roboto text-[16px]">
            Build bridges between AI and your existing systems for seamless
            orchestration and interoperability.
          </p>

          <div className="flex flex-col gap-[30px] ">
            {features.map((feature, index) => (
              <div
                className="w-[654px] h-[124px] shrink-0 flex flex-col justify-between p-[20px] rounded bg-white shadow-[inset_0px_0px_0px_1.171px_#E1E5EB,_0px_1.171px_3.514px_rgba(31,34,41,0.08)]"
                key={index}
              >
                <div className="flex gap-[18px]">
                  <img
                    src={feature.icon}
                    alt=""
                    className="w-[30px] h-[30px]"
                  />
                  <h3 className="text-[#2D3139] font-roboto text-2xl font-medium leading-[28.11px]">
                    {feature.text}
                  </h3>
                </div>
                <p className="text-[#2D3139] font-roboto text-base font-light leading-6">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuildIntegration;